import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  & > * {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import SvgIcon from './SvgIcon';
import { ICON_LARGE_SIZE, ICON_SIZE } from '../constants';
import IconWrapper from './components/IconWrapper';
import { getDefined } from '../helpers/common';
import { useDeviceType } from '../hooks';
import { absoluteCenteredStyle } from '../tokens/centered';
import { getIcon, getIconColor, getIconHoverColor } from '../helpers/icons';
var Wrapper = styled(IconWrapper)(_templateObject(), absoluteCenteredStyle);
var IconDefault = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var _ref$flex = _ref.flex,
      flex = _ref$flex === void 0 ? true : _ref$flex,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$inactive = _ref.inactive,
      inactive = _ref$inactive === void 0 ? false : _ref$inactive,
      _ref$hasArrow = _ref.hasArrow,
      hasArrow = _ref$hasArrow === void 0 ? false : _ref$hasArrow,
      _ref$hasClose = _ref.hasClose,
      hasClose = _ref$hasClose === void 0 ? false : _ref$hasClose,
      icon = _ref.icon,
      color = _ref.color,
      colorHover = _ref.colorHover,
      colorActive = _ref.colorActive,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? 'right' : _ref$arrow,
      _ref$pointer = _ref.pointer,
      pointer = _ref$pointer === void 0 ? false : _ref$pointer,
      className = _ref.className,
      size = _ref.size,
      style = _ref.style,
      props = _objectWithoutPropertiesLoose(_ref, ["flex", "disabled", "inactive", "hasArrow", "hasClose", "icon", "color", "colorHover", "colorActive", "arrow", "pointer", "className", "size", "style"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  return /*#__PURE__*/React.createElement(Wrapper, {
    ref: forwardedRef,
    flex: flex,
    pointer: pointer,
    disabled: disabled,
    inactive: inactive,
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(SvgIcon, _extends({
    flex: true,
    size: size != null ? size : hasArrow ? ICON_LARGE_SIZE : ICON_SIZE,
    color: getDefined(color, getIconColor(disabled)),
    colorHover: hasTouchScreen ? null : getDefined(colorHover, colorActive, getIconHoverColor(disabled))
  }, props), icon || getIcon(hasArrow, hasClose, arrow)));
});
export default IconDefault;